// extracted by mini-css-extract-plugin
export var cardHeader = "_h7-0";
export var reorderHandle = "_h7-3";
export var titleArea = "_h7-1";
export var titleAreaWithHandle = "_h7-2";